import React, { useCallback } from 'react';
import { Tab, Tabs } from '@mui/material';
import { useRecoilState } from 'recoil';
import stateResultMode from '../../state/stateResultMode';


function ResultsViewSelector() {
    const [resultsView, setResultsView] = useRecoilState(stateResultMode);
    const handleChange = useCallback((event: React.SyntheticEvent<Element, Event>, value: any) => {
        if (value !== resultsView) {
            setResultsView(value);
        }
    }, [resultsView, setResultsView]);

    return (
        <Tabs centered value={resultsView} onChange={handleChange}>
            <Tab value="biosamples" label="Biosamples" />
            <Tab value="variants" label="Variants" />
        </Tabs>
    );
}


export default ResultsViewSelector;
